import { ButtonBase, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

interface Props {
    name: string;
    isSelected: boolean;
    onSelect: () => void;
    dataTestId?: string;
}

const useStyles = makeStyles((theme: any) => ({
    card: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        width: '100%',
        boxSizing: 'border-box',
        minHeight: '3.25rem',
        padding: '1rem',
        backgroundColor: theme.palette.common.white,
        border: theme.border.light,
        borderRadius: theme.radius.field,
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'border-color 200ms ease',
        '&:hover': {
            borderColor: theme.palette.common.yellow,
        },
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.common.darkGrey}`,
            outlineOffset: -4,
        },
    },
    selected: {
        borderColor: theme.palette.common.yellow,
        backgroundColor: theme.palette.common.lightBrown,
    },
    name: {
        ...theme.typography.body1,
        color: theme.palette.common.darkGrey,
        margin: 0,
        minWidth: 0,
        overflowWrap: 'anywhere',
    },
}));

export const CategoryCard = ({ name, isSelected, onSelect, dataTestId }: Props) => {
    const classes = useStyles();
    return (
        <ButtonBase
            className={clsx(classes.card, isSelected && classes.selected)}
            onClick={onSelect}
            aria-pressed={isSelected}
            data-testid={dataTestId}
        >
            <Typography className={classes.name} component="span">
                {name}
            </Typography>
        </ButtonBase>
    );
};
